import { render, staticRenderFns } from "./DeliveryDetail.vue?vue&type=template&id=01e24fd6&scoped=true"
import script from "./DeliveryDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e24fd6",
  null
  
)

export default component.exports